module.exports = __webpack_public_path__ + "h5/img/milestone-victoria-harbour.97540304.webp";